export class ProcessInfo {
    /**
     * 业务活动ID
     */
    bizObjId: string;
    /**
     * Key
     */
    processKey: string;
    /**
     * 流程名称
     */
    processName: string;
    /**
     * 流程编号
     */
    processCode: string;
    /**
     * 流程分类ID
     */
    flowFormId: string;
    /**
     * 流程分类名称
     */
    flowFormName: string;
    /**
     * 流程类型
     */
    startMode?: string;
    /**
     * 流程组织
     */
    procOrg?: ProcessOrganization;
    /**
     * 访问级别
     */
    accessLevel?: string;
    /**
     * 流程名称国际化
     */
    processNameLanguage?: Map<String, String>;
}


export class ProcessOrganization {
    orgName: string;
    orgId: string;
}
